// test1581
(1581 && 0);
